// Whether the participant may see and act on employers/roles. Mirrors the
// backend's ApplicationContainer#show_employers? (programme employer page on,
// stage inside the employer-visible window, live placement status visible),
// plus the PMF-only rule that exclusively recommended participants on the new
// placement flow only see their recommendations. Fails closed while the menu
// is still loading, so nothing is offered before the answer is known.
export const canAccessRoles = (menu, newPlacementFlowOn) =>
  !!menu?.showEmployers && !(newPlacementFlowOn && !!menu?.exclusivelyRecommended)

// Whether the menu has come back yet. Until it has, nothing is known about what
// this participant may see, so a route guard has to wait rather than decide.
export const menuAnswered = (menu) => !!menu?.loaded
